import {ref, type Ref} from 'vue'
import {openToast} from '~/composables/openToast'

const activeAbortControllers = new Set<AbortController>()

export async function useFetchWithToken<T>(functionName: string, url: string, options: any, loading: Ref<boolean> = ref(false)): Promise<T | undefined> {
    const {$auth} = useNuxtApp()
    const runtimeConfig = useRuntimeConfig()
    const languageStore = useLanguageStore()
    const user = await $auth.getUser()
    const correlationId = crypto.randomUUID()
    const abortController = new AbortController()
    activeAbortControllers.add(abortController)

    try {
        loading.value = true
        return await $fetch<T>(url, {
            ...options,
            signal: abortController.signal,
            headers: {
                ...options?.headers,
                Authorization: `Bearer ${user?.access_token}`,
                'Accept-Language': languageStore.currentLanguage?.id ?? 'fr',
                'X-Api-Key': runtimeConfig.public.myefficiencyApiKey,
                'X-Correlation-ID': correlationId,
            },
            async onResponseError({request, response}) {
                if (
                    response.status === 404 &&
                    ['diagnostic', 'theme', 'subtheme', 'question'].some(kw => request.toString().includes(kw))
                ) {
                    openToast('error', "L'élément sur lequel vous travailliez n'existe pas/ou n'est plus disponible.")
                    useDecathlonStores().setSelectedCrossDiag(undefined)
                    await navigateTo('/choose-diag')
                }
            },
        })
    } catch (e: any) {
        if (isCanceledError(e)) {
            return undefined //
        }
        throw e
    } finally {
        loading.value = false
        activeAbortControllers.delete(abortController)
    }
}


function isCanceledError(e: any): boolean {
    return (
        e?.name === 'AbortError' ||
        e?.code === 'ERR_CANCELED' ||
        e?.message?.toLowerCase?.().includes('aborted')
    )
}


// 🔥 utilisé par le plugin uniquement
export function cancelActiveRequests() {
    activeAbortControllers.forEach(controller => controller.abort())
    activeAbortControllers.clear()
}
